/**
 * Transforms prompt answers for API submission.
 * @param {Array} promptAnswers - The array of prompt answers to transform.
 * @returns {Array} Transformed prompt answers ready for API submission.
 */
export const transformPromptAnswers = (promptAnswers) => {
  const preparedAnswers = promptAnswers.reduce((acc, { field, values }) => {
    if (Array.isArray(values)) {
      if (acc[field]) {
        acc[field] = [...acc[field], ...values];
      } else {
        acc[field] = values;
      }
    } else if (typeof values === 'object' && values.date_range) {
      acc[field] = values.date_range;
    }
    return acc;
  }, {});

  return {
    ...preparedAnswers,
  };
};

/** * Filters prompts based on the fast track ID.
 * @param {Object[]} prompts - The array of prompts to filter.
 * @returns {Object[]} Filtered prompts.
 */
export const filterPrompts = (prompts) => {
  const filteredPrompts = prompts.filter((prompt) => prompt?.isAdvanced === false);

  return filteredPrompts;
};
